import React from 'react';
import FooterMenu from './footer/footer';

const Footer = () => <FooterMenu />;

export default Footer;
